import { observable, action, flow, computed } from 'mobx';
import { rstr2b64 } from 'utils/md5';
import Util from 'utils';
import Config from 'config/Config';
import { Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './indexServ';

class BankSearch {
  // 地址
  @observable address = null;

  // 主行id
  @observable headBankId = '';

  // 支行列表
  @observable branchBankList = [];

  // 搜索支行关键词
  @observable keyword = '';

  /**
   * 修改逻辑参数
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 获取银行支行列表
   */
  getBranchBankList = flow(function* () {
    try {
      const [province, city] = this.address || [];
      let params = {
        headBankId: this.headBankId
      };
      if (province && city) {
        params.provinceCode = province.value;
        params.cityCode = city.value;
      }
      const { data } = yield Serv.getBranchBankList(params);
      if (Array.isArray(data)) {
        this.branchBankList = data.map((_val) => ({
          label: _val.name,
          value: `${_val.id}`,
          name: _val.name,
          code: _val.code,
          provinceCode: _val.provinceCode,
          cityCode: _val.cityCode
        }));
      }
    } catch (error) {}
  });

  @computed
  get bankList() {
    return this.branchBankList.filter((item) => item.name.indexOf(this.keyword) != -1);
  }
}
export default BankSearch;



// WEBPACK FOOTER //
// ./src/pubBiz/BankSearch/indexMod.js